/* eslint-disable */

import Liveness from './components/liveness/liveness';

export default Liveness
